import React from 'react';
import AboutMe from '../../AboutMe/AboutMe';
import AllProjects from '../../AllProjects/AllProjects';
import Blog from '../../Blog/Blog';
import ContactMe from '../../ContactMe/ContactMe';
import Education from '../../Education/Education';
import MyIntro from '../../MyIntro/MyIntro';
import Projects from '../../Projects/Projects';
import Skills2 from '../../Skills/Skills2';
import SocialMedia from '../../SocialMedia/SocialMedia';
import NewPageSticky from '../../NewPageSticky/NewPageSticky';
import useTitle from '../../../Hooks/useTitle';
import Language from '../../Language/Language';




const Home = () => {
    
    
    useTitle('Portfolio | Fahim Faysal')
    
    return (
        <div>
            <MyIntro></MyIntro>
            <Projects></Projects>
            {/* <AllProjects></AllProjects> */}
            <Skills2></Skills2>
            <AboutMe></AboutMe>
            <Blog></Blog>
            <Education></Education>
            <ContactMe></ContactMe>
            <SocialMedia></SocialMedia>

            {/* This NewPageSticky Not Works */}
            {/* <NewPageSticky></NewPageSticky> */}

            {/* <Language></Language> */}
        </div>
    );
};

export default Home;